import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'react-modal';
import SVGInline from 'react-svg-inline'

// components
import {
    DescriptionBox,
    MediaMobile,
    RoundTypeButton
} from '../ModalElements';
import {clientMedia, connection} from "../../../Config/Settings";
import { NavigationMobile } from "../../Modals/Navigation";

// actions
import { closeNavModal, openNavModal } from '../../../Actions/main';
import { openPinFullViewModal } from '../../../Actions/modals';

// utils
import {
    capitalize,
    getHours, getIamACat,
    getInstrumentIcon, invertBandFinder,
    makeLinkPretty,
    shortenStr
} from '../../../utils';

// consts
import { LIVE_MUSIC, SERVICE, BAND, MUSICIAN} from '../../../consts';

// svgs
import scopWhiteTxtSVG from '../../inlineSVGs/scopWhiteTxtSVG';
import arrowSideSVG from '../../inlineSVGs/arrowSideSVG';
import crossSVG from '../../inlineSVGs/crossSVG';
import mapPinSVG from '../../inlineSVGs/mapPinSVG';
import clockSVG from '../../inlineSVGs/clockSVG';
import phoneSVG from '../../inlineSVGs/phoneSVG';
import mailSVG from '../../inlineSVGs/mailSVG';
import linkSVG from '../../inlineSVGs/linkSVG';
import fbLinkSVG from '../../inlineSVGs/fbLinkSVG';

// styles
import './PinFullViewModalMobile.css';
import moment from "moment";


class PinFullViewModalMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pinNum: 0
        }
    }

    share() {
        const shareData = {
            title: `${this.props.pin.name} | Mugics`,
            text: this.props.pin.desc,
            url: `${connection().serverUrl}/pages?id=${this.props.pin._id}&ad=${this.props.pin._id}`
        };

        if (!navigator || !navigator.share) {
            this.fbShare(shareData.url);
            return;
        }

        navigator.share(shareData)
            .then()
            .catch(err => console.log('failed native share', err));
    }

    fbShare(pinUrl) {
        // const images = this.props.pin && this.props.pin.images ? this.props.pin.images.map((image) => {
        //     return {original: image.src, thumbnail: image.thumbnail};
        // }) : [];
        // window.location.href
        // const shareObject = {
        //     'og:url': `${connection().serverUrl}/pages?id=${this.props.pin._id}&ad=${this.props.pin._id}`,
        //     'og:title': this.props.pin.name,
        //     'og:description': this.props.pin.desc || 'Check this event on Mugics',
        //     'og:image': images[0] ? images[0].original : 'https://s3.amazonaws.com/mugics-events-images-new/img/logos/listen-logo.png',
        //     'og:image:url': images[0] ? images[0].original : 'https://s3.amazonaws.com/mugics-events-images-new/img/logos/listen-logo.png',
        // };
        //
        // window.FB.ui({
        //     method: 'share_open_graph',
        //     action_type: 'og.shares',
        //     action_properties: JSON.stringify({
        //         object : shareObject
        //     })
        // }, () => {});

        window.FB.ui({
            method: 'share',
            display: 'popup',
            href: pinUrl,
        }, function(res){});

    }

    onSelectNavType(type) {
        if (!this.props.pin.location || !this.props.pin.location.position) return;

        const { position, street, number } = this.props.pin.location;

        let navUrl = '';

        // open Waze
        if (type === 'waze') {
            let navWazeSuffix = `ul?ll=${position.lat},${position.lng}&navigate=yes&zoom=17`;

            navUrl = `https://waze.com/${navWazeSuffix}`;
            window.open(navUrl, '_blank');
            return;
        }

        if (type === 'googlemaps') {
            let navGoolgeVars = `${position.lat},${position.lng}`;

            if (street && number) {
                navGoolgeVars = `${street}+${number}`
            }
            navUrl = `http://maps.google.com/maps/search/?api=1&query=${navGoolgeVars}&navigate=yes`;
            window.open(navUrl, '_blank');
        }
    }

    handleDescScroll(val) {
    }

    handleCloseModal() {
        if (window && window.history) {
            window.history.replaceState('', '', '/');
        }

        this.props.closeModal();
    }

    calcMediaWidth() {
        // modal is 87% width
        const mainMediaWidth = (window.innerWidth * 0.95) * 0.55;

        // modal is 92% height
        // const mainMediaHeight = window.innerHeight * 0.92;

        return mainMediaWidth;

        // return mainMediaWidth && mainMediaWidth / MEDIA_REL_SIZE_WIDTH / (mainMediaWidth / mainMediaHeight);
    }

    calcMediaHeight() {
        // modal is 80% width

        // const mainMediaWidth = window.innerWidth * 0.8;

        // modal is 92% height
        // const mainMediaHeight = window.innerHeight * 0.92;
        return this.calcMediaWidth() / 1.5;
        // return mainMediaHeight && mainMediaHeight / MEDIA_REL_SIZE_HEIGHT / (mainMediaWidth / mainMediaHeight);
    }

    getMedia() {
        if (!this.props.pin) return [];

        const imagesUrl = this.props.pin.images.map(imgObj => imgObj.src) || [];

        if (this.props.pin.video) {
            return [this.props.pin.video_embed, ...imagesUrl];
        }

        return [...imagesUrl];
    }

    getPriceTag(pin) {
        if (!pin.prices) return '';

        const { prices } = this.props.pin;

        if (prices.priceType === 'free') return 'חינם';
        if (prices.priceType === 'hat') return 'כובע';

        if (prices.price === 0) return `${prices.min} - ${prices.max} ${prices.currency === 'ILS' ? '₪' : prices.currency}`;

        if (prices.price !== 0) return `${prices.price} ${prices.currency === 'ILS' ? '₪' : prices.currency}`;
    }

    nextPin(pin) {
        let pinIndex = 0;
        this.props.pagePins.forEach((p, i) => {
            if (p.name === pin.name) {
                pinIndex = i + 1;

                if (pinIndex === this.props.pagePins.length) {
                    pinIndex = 0;
                }

                return -1;
            }
        });

        this.props.openPinFullViewModal(this.props.pagePins[pinIndex]);
    }

    prevPin(pin) {
        let pinIndex = 0;
        this.props.pagePins.forEach((p, i) => {
            if (p.name === pin.name) {
                pinIndex = i - 1;

                if (pinIndex < 0) {
                    pinIndex = this.props.pagePins.length - 1;
                }

                return -1;
            }
        });

        this.props.openPinFullViewModal(this.props.pagePins[pinIndex]);
    }

    // render methods
    renderBandFinderType() {
        if (!this.props.pin || (this.props.pin.type !== BAND && this.props.pin.type !== MUSICIAN)) return null;

        const prefixText = this.props.pin.type === BAND ? 'אנחנו' : 'אני';
        const suffixText = this.props.pin.type === BAND ? '' : '';

        return (
            <div className={`band-finder-type ${this.props.pin.type}`}>
                {`${prefixText} ${getIamACat(this.props.pin.iWeAre, this.props.datatypes.categories[this.props.pin.type])} ${suffixText}`}
            </div>
        )
    }

    // only for band finder pins - band or musician
    renderBandFinderLookingFor() {
        if (!this.props.pin || (this.props.pin.type !== BAND && this.props.pin.type !== MUSICIAN)) return null;

        const topMargin = !this.props.pin.desc || this.props.pin.desc.length < 100 ? 'full' : '';

        const lookingForArr = [];
        this.props.pin.lookingForTypes.forEach(t => {
           const lfType = getIamACat(t, this.props.datatypes.categories[invertBandFinder(this.props.pin.type)]);
           if (lfType) lookingForArr.push(lfType)
        });

        const { street = '', number = '', country = '', city = '' } = this.props.pin.location || {};

        return (
            <div className={`band-finder-looking-for ${this.props.pin.type} ${topMargin}`}>
                <div className={`band-finder-icon-wrapper ${this.props.pin.type}`}>
                    <SVGInline className="band-finder-icon" svg={scopWhiteTxtSVG} component="i"/>
                </div>
                <p className="mini-header">{this.props.pin.type === MUSICIAN ? 'מחפש.ת' : 'מחפשים:'}</p>
                <div className="looking-for-string">{lookingForArr.length > 1 ? lookingForArr.join(', ') : lookingForArr[0]}</div>
                <div className="band-finder-address-wrapper">
                    <SVGInline className={`map-icon ${this.props.pin.type}`} svg={mapPinSVG} component="i"/>
                    <div className="address">{` - ${city || country} ${street} ${number}`}</div>
                </div>
            </div>
        )
    }

    renderHeader(pin) {
        return (
            <div className={`modal-header-wrapper ${pin.type}`}>
                {this.props.pagePins.length > 1 ?
                    <div className="left-wrapper">

                        <div className={`arrow left ${pin.type}`} onClick={() => this.prevPin(pin)}>
                            <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                        </div>
                        <div className={`arrow right ${pin.type}`} onClick={() => this.nextPin(pin)}>
                            <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                        </div>
                    </div> : null
                }

                <div className="center-wrapper">
                    {pin.type === BAND
                        ?
                        <div className="i-we-are-title">{` אנחנו ${getIamACat(pin.iWeAre, this.props.datatypes.categories[this.props.pin.type])}`}</div> : null}
                    {pin.type === MUSICIAN
                        ?
                        <div className="i-we-are-title">{` אני ${getIamACat(pin.iWeAre, this.props.datatypes.categories[this.props.pin.type])}`}</div> : null}
                    {pin.type === LIVE_MUSIC || pin.type === SERVICE ?
                        <span>
                            {this.getPriceTag(pin)}
                            {/*{pin.prices.priceType !== 'free' ?*/}
                            {/*    <SVGInline className="coin-icon" svg={coinSVG} component="i"/>*/}
                            {/*    : null}*/}
                        </span>
                        : null}

                </div>

                <div className="right-wrapper">
                    <div className="close-button-container" onClick={() => this.handleCloseModal()}>
                        <SVGInline className={`cross-icon ${pin.type}`} svg={crossSVG} component="i"/>
                    </div>
                </div>
            </div>
        )
    }

    renderRoundButtons(pin) {
        return (
            <div className="round-buttons-wrapper">
                {pin.ticketLink ?
                    <RoundTypeButton
                        handleClick={() =>  window.open(pin.ticketLink, '_blank')}
                        buttonType="tickets"
                        customClass="round-button"
                        type={pin.type}
                    /> : null
                }

                {pin.phone ?
                    <RoundTypeButton
                        handleClick={() => window.open(`tel:${pin.phone}`, '_self')}
                        buttonType="phone"
                        customClass="round-button"
                        type={pin.type}
                    /> : null
                }
                <RoundTypeButton handleClick={this.props.openNavModal} buttonType="location" customClass="round-button" type={pin.type}/>
                <RoundTypeButton handleClick={() => this.share()} buttonType="share" customClass="round-button" type={pin.type}/>
            </div>
        )
    }

    getCatImg(musicType) {
        return `url(${clientMedia()}/img/categoriesNeon/${musicType}.svg`
    }

    getEventDate(date, time) {
        if (!date || !time) return '';

        const hoursStr = getHours(time)
        const dateStr = moment(date).format('ddd, MMM D');
        return `${dateStr} - ${hoursStr}`
    }

    // liveMusic and service subheader
    renderSubTitle(pin) {
        if (pin.type === BAND || pin.type === MUSICIAN) return null;

        const { street = '', number = '', country = '', city = '' } = pin.location || {};

        return (
            <div className="sub-title-wrapper">
                <SVGInline className={`map-icon ${pin.type}`} svg={mapPinSVG} component="i"/>
                <div className="address">
                    <p className="city-mobile">{`${city || country || ''}`}</p>
                    <p className="address-mobile">{`${street || ''} ${number || ''}`}</p>
                </div>
                {pin.type === LIVE_MUSIC ? <SVGInline className={`clock-icon ${pin.type}`} svg={clockSVG} component="i"/> : null}
                {pin.type === LIVE_MUSIC ? <div className="time">{`${this.getEventDate(pin.date,pin.time)}`}</div> : null}
            </div>
        )
    }

    renderTextSection(pin) {
        return (
            <div className="text-section-wrapper">
                <div className="title-wrapper">
                    <p className="title">{capitalize(pin.name)}</p>
                    <div className="pin-category" style={{backgroundImage: this.getCatImg(pin.category)}} />
                </div>

                {this.renderSubTitle(pin)}
                <DescriptionBox
                    text={pin.desc}
                    customClass="description-mobile"
                    onScroll={val => this.handleDescScroll(val)}
                    isMobileSeeMore={this.state.isMobileSeeMore}
                    handleToggleSeeMore={() => this.setState({ isMobileSeeMore: !this.state.isMobileSeeMore})}
                />
            </div>
        )
    }

    // PLAYING ON STAGE
    renderPlayingOnStage(pin) {
        if (!pin.instruments || pin.instruments.length < 1) return null;

        return (
            <div className="playing-on-stage-wrapper">
                <div className="title">מנגנים על הבמה</div>
                <div className="instruments">
                    {pin.instruments.map((instrument, index) => {
                        return (
                            <div
                                key={`instrument-icon-${index}`}
                                className={`instrument-icon`}
                                style={{backgroundImage: `url(${getInstrumentIcon(instrument, true)})`}}
                            ></div>
                        )
                    })}
                </div>
            </div>
        )
    }

    // CONTACT & LINKS
    renderContactAndLinks(pin) {
        if (!pin.phone && !pin.email && !pin.link1 && !pin.link2 && !pin.fblink) return null;

        return (
            <div className={`contact-and-links-wrapper ${pin.type}`}>
                <div className="title">צרו קשר</div>
                {pin.phone ?
                    <div className="link-wrapper" onClick={() => window.open(`tel:${pin.phone}`, '_self')}>
                        <SVGInline className={`icon phone`} svg={phoneSVG} component="i"/>
                        <span>{pin.phone}</span>
                    </div>: null
                }

                {pin.email ?
                    <div className="link-wrapper" onClick={() => window.open(`mailto:${pin.email}, '_self`)}>
                        <SVGInline className={`icon email`} svg={mailSVG} component="i"/>
                        <span>{shortenStr(pin.email, 27)}</span>
                    </div> : null
                }
                {pin.fblink ?
                    <div className="link-wrapper" onClick={() => window.open(pin.fblink, '_blank')}>
                        <SVGInline className={`icon fblink`} svg={fbLinkSVG} component="i"/>
                        <span>{shortenStr(makeLinkPretty(pin.fblink), 27)}</span>
                    </div> : null
                }
                {pin.link1 ?
                    <div className="link-wrapper" onClick={() => window.open(pin.link1, '_blank')}>
                        <SVGInline className={`icon link1`} svg={linkSVG} component="i"/>
                        <span>{shortenStr(makeLinkPretty(pin.link1), 27)}</span>
                    </div> : null
                }
                {pin.link2 ?
                    <div className="link-wrapper" onClick={() => window.open(pin.link2, '_blank')}>
                        <SVGInline className={`icon link2`} svg={linkSVG} component="i"/>
                        <span>{shortenStr(makeLinkPretty(pin.link2), 27)}</span>
                    </div> : null
                }
            </div>
        )
    }

    render() {
        if (!this.props.pin) return null;

        return (
            <Modal
                isOpen={this.props.isModalOpen}
                contentLabel="Modal"
                className={`pin-modal-mobile-outer-wrapper rtl`}
                style={{overlay: {
                        backgroundColor: 'rgba(37, 14, 71, 1)'
                    }}}
            >

                {this.renderHeader(this.props.pin)}

                <MediaMobile
                    pin={this.props.pin}
                    media={this.getMedia()}
                    mainMediaWidth={this.calcMediaWidth()}
                    mainMediaHeight={this.calcMediaHeight()}
                />
                {this.renderBandFinderLookingFor(this.props.pin)}

                <div className={`pin-full-view-mobile-main-content ${this.props.pin.type}`}>
                    {this.renderRoundButtons(this.props.pin)}
                    {this.renderTextSection(this.props.pin)}
                    {this.renderPlayingOnStage(this.props.pin)}
                    {this.renderContactAndLinks(this.props.pin)}
                </div>
                <NavigationMobile
                    isModalOpen={this.props.isNavModalOpen}
                    closeModal={this.props.closeNavModal}
                    onSelectNav={(type) => this.onSelectNavType(type)}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => ({
    pin: state.modals.pinFullViewData,
    isNavModalOpen: state.main.isNavModalOpen,
    pagePins: state.main.pinsNew,
    datatypes: state.main.datatypes
});

PinFullViewModalMobile.propTypes = {
    isModalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    modalType: PropTypes.string,

    // global state props
    pin: PropTypes.object,
    isNavModalOpen: PropTypes.bool,
    pagePins: PropTypes.array,
    datatypes: PropTypes.object,

    // actions
    openNavModal: PropTypes.func,
    closeNavModal: PropTypes.func,
    openPinFullViewModal: PropTypes.func
};

PinFullViewModalMobile.defaultProps = {
    modalType: 'liveMusic'
};

export default connect(mapStateToProps, {
    openNavModal,
    closeNavModal,
    openPinFullViewModal
})(PinFullViewModalMobile);




// WEBPACK FOOTER //
// ./src/Components/ModalsNew/PinFullViewModalMobile/PinFullViewModalMobile.js